import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideConfig, UrlModule } from '@spartacus/core'
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../shared/material.module'
import { SharedModule } from '../../../../shared/shared.module'
import { NewDispenserAgreementComponent } from './new-dispenser-agreement.component'

@NgModule({
  declarations: [NewDispenserAgreementComponent],
  imports: [
    RouterModule,
    UrlModule,
    SharedModule,
    MaterialModule,
    SpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        CreateDispenserAgreementComponent: {
          component: NewDispenserAgreementComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class NewDispenserAgreementModule {}
